import * as React from 'react';
import { Bar, HorizontalBar } from 'react-chartjs-2';
import Chartify from '@shipsy/chartify';
import { colorMappingForDelayChart, colorMappingForVesselDepartureChart } from 'src/Library/Constants';

class BarViz extends React.PureComponent<any, any> {
  render() {
    const { formData, chartData } = this.props;
    const chartifyInstance = new Chartify.BarData(chartData, formData);
    let chartifyData = chartifyInstance.getManipulatedChartDataAndOptions();

    if (formData.metadata) {
      chartifyData = {
        ...chartifyData,
        options: {
          ...chartifyData.options,
          legend: {
            position: formData.metadata.position,
            display: formData.metadata.display,
            labels: {
              boxWidth: 5,
              fontSize: 10,
              usePointStyle: true,
            },
          },
          tooltips: {
            enabled: true,
            mode: 'point',
            caretSize: 10,
          },
          scales: {
            xAxes: [{
              barPercentage: 0.5,
              barThickness: 20,
              stacked: true,
              gridLines: {
                offsetGridLines: false,
                display: false,
              },
              ticks: {
                fixedStepSize: 1,
                precision: 1,
                beginAtZero: true,
                callback: (val) => (typeof(val) !== 'number' || (Math.floor(val) === val)) ? val : undefined,
              },
              scaleLabel: {
                display: this.props.labelStringX,
                labelString: this.props.labelStringX,
              },
            }],
            yAxes: [{
              barPercentage: 0.5,
              barThickness: 20,
              stacked: true,
              gridLines: {
                offsetGridLines: false,
                display: true,
              },
              scaleLabel: {
                display: this.props.labelStringY,
                labelString: this.props.labelStringY,
              },
              ticks: {
                fixedStepSize: 1,
                beginAtZero: true,
                precision: 1,
                callback: (val) => (typeof(val) !== 'number' || (Math.floor(val) === val)) ? val : undefined,
              },
            }],
          },
          layout: {
            padding: {
              left: 20,
            },
          },
        },
      };
    }

    chartifyData?.data?.barChartData?.datasets?.forEach((dataSet) => {
      if (dataSet?.key in colorMappingForDelayChart) {
        dataSet.borderColor = colorMappingForDelayChart[dataSet?.key];
        dataSet.backgroundColor = colorMappingForDelayChart[dataSet?.key];
      }

      if (dataSet?.key in colorMappingForVesselDepartureChart) {
        dataSet.borderColor = colorMappingForVesselDepartureChart[dataSet?.key];
        dataSet.backgroundColor = colorMappingForVesselDepartureChart[dataSet?.key];
      }
      
    });

    return (formData.bar_type === 'horizontal') ? (
      <HorizontalBar data={chartifyData.data.barChartData}
        getElementAtEvent={(e) => {
          if (!this.props.onClick) return;
          this.props.onClick(e);
        }}
        options={chartifyData.options}></HorizontalBar>
    ) : (<Bar
      getElementAtEvent={(e) => {
        if (!this.props.onClick) return;
        this.props.onClick(e);
      }}
      data={chartifyData.data.barChartData}
      options={chartifyData.options}
    />);
  }
}

export default BarViz;
